import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { Link } from 'react-router-dom';
import { getHost } from './config';
import {
  CURRENT_TERMS_VERSION,
  grantAnalyticsConsent,
  trackEvent,
} from './analytics';
import './custom.scss';

export default function TermsAcceptanceModal({ show, onAccepted }) {
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [acceptedPrivacy, setAcceptedPrivacy] = useState(false);
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const canSubmit = acceptedTerms && acceptedPrivacy && !submitting;

  const handleSubmit = async () => {
    if (!canSubmit) return;

    setSubmitting(true);
    setError('');

    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${getHost()}/api/accept-terms`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          acceptedTerms: true,
          acceptedPrivacy: true,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        setError(data.message || 'Η αποδοχή δεν ολοκληρώθηκε. Προσπαθήστε ξανά.');
        return;
      }

      if (data.token) {
        localStorage.setItem('authToken', data.token);
      }
      if (data.refresh_token) {
        localStorage.setItem('refreshToken', data.refresh_token);
      }

      trackEvent('terms_accepted', { terms_version: CURRENT_TERMS_VERSION });
      grantAnalyticsConsent();

      setAcceptedTerms(false);
      setAcceptedPrivacy(false);
      onAccepted?.();
    } catch {
      setError('Σφάλμα δικτύου. Προσπαθήστε ξανά.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      show={show}
      backdrop="static"
      keyboard={false}
      centered
      size="lg"
      onHide={() => {}}
    >
      <Modal.Header>
        <Modal.Title>Ενημέρωση όρων χρήσης</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-3">
          Οι <strong>Όροι Χρήσης</strong> και η <strong>Πολιτική Απορρήτου</strong> έχουν
          ενημερωθεί. Για να συνεχίσετε, διαβάστε και αποδεχτείτε τα παρακάτω.
        </p>
        <Form.Check
          className="mb-2 custom-label"
          type="checkbox"
          id="terms-acceptance-terms"
          label={
            <>
              Έχω διαβάσει και αποδέχομαι τους{' '}
              <Link to="/terms-of-use" target="_blank" rel="noopener noreferrer" className="footer-links">
                όρους χρήσης
              </Link>.
            </>
          }
          checked={acceptedTerms}
          onChange={(e) => setAcceptedTerms(e.target.checked)}
        />
        <Form.Check
          className="mb-3 custom-label"
          type="checkbox"
          id="terms-acceptance-privacy"
          label={
            <>
              Έχω διαβάσει και αποδέχομαι την{' '}
              <Link to="/privacy-policy" target="_blank" rel="noopener noreferrer" className="footer-links">
                πολιτική απορρήτου
              </Link>.
            </>
          }
          checked={acceptedPrivacy}
          onChange={(e) => setAcceptedPrivacy(e.target.checked)}
        />
        {error && <p className="text-danger small mb-0">{error}</p>}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={handleSubmit} disabled={!canSubmit}>
          {submitting ? 'Αποθήκευση…' : 'Αποδοχή και συνέχεια'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
